import { inject, Injectable } from "@angular/core";
import { catchError, combineLatest, EMPTY, map, Observable } from "rxjs";
import { toFieldStringArray } from "../../../../common/utils/object-paths";
import { ApiService } from "../../../api/packbo/api.service";
import { readItemsNavbar } from "../../../api/packbo/fn/items/read-items-navbar";
import { readItemsProductCategories } from "../../../api/packbo/fn/items/read-items-product-categories";
import { NavigationStore } from "./navigation.store";

@Injectable()
export class NavigationService {
    private readonly store = inject(NavigationStore);
    private readonly apiService = inject(ApiService);

    public loadNavbarContent(): Observable<void> {
        const navBarFields = toFieldStringArray({
            login_navigation_item_ref: {
                id: null,
                url: null,
                translations_refs: {
                    languages_code: null,
                    title: null
                }
            },
            membership_navigation_item_ref: {
                id: null,
                url: null,
                translations_refs: {
                    languages_code: null,
                    title: null
                },
                page_ref: {
                    translations_refs: {
                        languages_code: null,
                        slug: null
                    }
                }
            },
            navigation_items_refs: {
                navigation_items_id: {
                    id: null,
                    type: null,
                    page_ref: {
                        translations_refs: {
                            languages_code: null,
                            slug: null
                        }
                    },
                    translations_refs: {
                        languages_code: null,
                        title: null
                    }
                }
            }
        });

        const categoryFields = toFieldStringArray({
            id: null,
            icon: null,
            image: null,
            translations_refs: {
                languages_code: null,
                slug: null,
                title: null,
                description: null
            }
        });

        const nabBarItemObs = this.apiService.invoke(readItemsNavbar, { fields: navBarFields }).pipe(
            map((navbarItem) => {
                this.store.setNavbarDefinition(navbarItem.data ?? null);
            }),
            catchError(() => EMPTY)
        );

        const filters = JSON.stringify({ parent_ref: { _null: true } });
        const categorieItemsObs = this.apiService
            .invoke(readItemsProductCategories, { fields: categoryFields, filter: filters })
            .pipe(
                map((categorieItems) => {
                    this.store.setCategories(categorieItems.data ?? []);
                }),
                catchError(() => EMPTY)
            );

        return combineLatest([categorieItemsObs, nabBarItemObs]).pipe(
            map(() => {
                return;
            })
        );
    }
}
